export const RetailerHomePath = '/retailer';
export const RetailerStoresPath = '/retailer/stores';
export const RetailerOrdersPath = '/retailer/orders';
export const RetailerSettingsPath = {
  profile: '/settings/profile',
  address: '/settings/address',
  businessAddress: '/settings/business-address',
  deliveryAddress: '/settings/delivery-address',
  currency: '/settings/currency',
  language: '/settings/language',
  notification: '/settings/notifications',
  password: '/settings/password',
  supplier: '/settings/suppliers',
};
